export default __webpack_public_path__ + "static/media/after-cf@3x.5401ff28.png";